import { createQuiz } from "@/components/quizEngine";

const traits = ["curious", "kind", "bold", "clever", "proud", "cheerful", "mysterious", "loyal", "creative"];

const bank = [
  ["You find a book of magic sigils in the market. You…", [
    ["Try drawing one right away", { curious: 3, bold: 1 }],
    ["Study it carefully first", { clever: 2 }],
    ["Show it to your friends", { cheerful: 2, kind: 1 }],
    ["Hide it. Some things are forbidden", { mysterious: 2 }],
    ["Copy the patterns into your sketchbook", { creative: 2 }],
  ]],
  ["Your favorite tool in the atelier:", [
    ["A fine-tipped ink pen", { clever: 1, creative: 2 }],
    ["A brand new sketchbook", { curious: 2 }],
    ["A cup of tea for everyone", { kind: 2 }],
    ["The oldest spellbook on the shelf", { mysterious: 1, proud: 1 }],
    ["The repair kit. Something always breaks", { loyal: 2 }],
  ]],
  ["A friend fails their magic test. You…", [
    ["Sit with them until they feel better", { kind: 3 }],
    ["Help them practice every day", { loyal: 2, kind: 1 }],
    ["Tell them to work harder", { proud: 2 }],
    ["Make them laugh", { cheerful: 2 }],
    ["Figure out what went wrong", { clever: 2 }],
  ]],
  ["Your ideal witch hat:", [
    ["Tall and classic", { proud: 2 }],
    ["Decorated with ribbons and charms", { cheerful: 1, creative: 2 }],
    ["Simple and practical", { loyal: 1, clever: 1 }],
    ["Wide brim that hides your eyes", { mysterious: 2 }],
    ["A little crooked, from adventures", { bold: 2, curious: 1 }],
  ]],
  ["A stranger in a brimmed cap offers you secret magic. You…", [
    ["Say no and walk away", { loyal: 2 }],
    ["Ask what it does, just to know", { curious: 3 }],
    ["Report them to the Knights Moralis", { proud: 1, clever: 1 }],
    ["Play along to learn their plan", { mysterious: 2, clever: 1 }],
    ["Tell them off loudly", { bold: 2 }],
  ]],
  ["How do you spend a free afternoon?", [
    ["Drawing new spell ideas", { creative: 3 }],
    ["Exploring the forest", { curious: 2, bold: 1 }],
    ["Practicing until it's perfect", { proud: 2, clever: 1 }],
    ["Napping in the sun", { creative: 1, cheerful: 1 }],
    ["Helping in town", { kind: 2, loyal: 1 }],
  ]],
  ["Which element do you like most?", [
    ["Water, calm and flowing", { kind: 2 }],
    ["Fire, bright and fierce", { bold: 2, proud: 1 }],
    ["Wind, free and playful", { cheerful: 2 }],
    ["Light, guiding the way", { loyal: 1, kind: 1 }],
    ["Shadow, full of secrets", { mysterious: 3 }],
  ]],
  ["Your spell goes wrong. You…", [
    ["Laugh and try again", { cheerful: 2, bold: 1 }],
    ["Fix it quietly before anyone sees", { proud: 2 }],
    ["Take notes on what happened", { clever: 2, curious: 1 }],
    ["Make sure no one got hurt", { kind: 2, loyal: 1 }],
    ["Turn the mistake into something new", { creative: 3 }],
  ]],
  ["What do you want most?", [
    ["To become a real witch", { bold: 1, curious: 2 }],
    ["To prove everyone wrong", { proud: 3 }],
    ["To keep my friends safe", { loyal: 3 }],
    ["To uncover the truth", { mysterious: 2, clever: 1 }],
    ["To make magic beautiful", { creative: 2, cheerful: 1 }],
  ]],
  ["Pick a magical creature:", [
    ["A gentle lake dragon", { kind: 2 }],
    ["A clever talking fox", { clever: 2 }],
    ["A wild storm bird", { bold: 2 }],
    ["A tiny fluffy familiar", { cheerful: 2 }],
    ["A strange creature no one has named", { curious: 2, mysterious: 1 }],
  ]],
  ["Your teacher gives you a hard lesson. You…", [
    ["Listen to every word", { loyal: 2, clever: 1 }],
    ["Ask a hundred questions", { curious: 3 }],
    ["Already know it, of course", { proud: 2 }],
    ["Try your own way instead", { creative: 2, bold: 1 }],
    ["Help the student next to you", { kind: 2 }],
  ]],
  ["Your room in the atelier looks like:", [
    ["Neat and organized", { clever: 1, proud: 1 }],
    ["Paper and ink everywhere", { creative: 3 }],
    ["Cozy, with plants and pillows", { kind: 1, cheerful: 1 }],
    ["Full of things you found outside", { curious: 2 }],
    ["Locked. No one goes in", { mysterious: 2 }],
  ]],
  ["Someone breaks the rules of magic to help a person. You think…", [
    ["Rules are rules", { proud: 1, loyal: 1 }],
    ["It depends on why", { clever: 2 }],
    ["Kindness matters more", { kind: 3 }],
    ["I'd do the same", { bold: 2 }],
    ["I'd keep their secret", { mysterious: 2, loyal: 1 }],
  ]],
  ["Your role in a group adventure:", [
    ["The one who charges ahead", { bold: 3 }],
    ["The planner", { clever: 3 }],
    ["The cheerleader", { cheerful: 3 }],
    ["The protector", { loyal: 3 }],
    ["The one who notices strange things", { curious: 2, mysterious: 1 }],
  ]],
  ["Pick a snack for a long day of spell practice:", [
    ["Sweet pastries", { cheerful: 2 }],
    ["Whatever someone made for me", { kind: 1, loyal: 1 }],
    ["Something I've never tried", { curious: 2 }],
    ["Tea and nothing else", { proud: 1, mysterious: 1 }],
    ["I forgot to eat, I was drawing", { creative: 3 }],
  ]],
  ["How do people describe you?", [
    ["Sweet and gentle", { kind: 3 }],
    ["Stubborn and strong", { proud: 2, bold: 1 }],
    ["Funny and bright", { cheerful: 3 }],
    ["Hard to read", { mysterious: 3 }],
    ["Full of ideas", { creative: 2, curious: 1 }],
  ]],
  ["You see magic for the very first time. You feel…", [
    ["Pure wonder", { curious: 3 }],
    ["I need to learn it now", { bold: 2, proud: 1 }],
    ["Happy to share it", { cheerful: 1, kind: 1 }],
    ["Suspicious of how it works", { clever: 2 }],
    ["Inspired to make my own", { creative: 3 }],
  ]],
  ["A little kid wants to learn magic. You…", [
    ["Teach them something small and safe", { kind: 2, loyal: 1 }],
    ["Warn them it's not a game", { proud: 1, clever: 1 }],
    ["Show them a dazzling trick", { cheerful: 2, creative: 1 }],
    ["Ask what they'd do with it", { curious: 1, mysterious: 1 }],
    ["Take them on an adventure", { bold: 2 }],
  ]],
  ["Pick a place to visit:", [
    ["The great city of witches", { proud: 1, curious: 1 }],
    ["A quiet seaside town", { kind: 2 }],
    ["A lively night market", { cheerful: 2 }],
    ["Ruins from the old days", { mysterious: 2, curious: 1 }],
    ["A shop full of magic pens", { creative: 2 }],
  ]],
  ["When you're upset, you…", [
    ["Keep it to yourself", { mysterious: 2, proud: 1 }],
    ["Talk to a close friend", { loyal: 2 }],
    ["Draw until I feel better", { creative: 2 }],
    ["Go outside and run", { bold: 2 }],
    ["Find a way to smile again", { cheerful: 2 }],
  ]],
  ["Your dream magic spell:", [
    ["Make flowers bloom anywhere", { kind: 2, cheerful: 1 }],
    ["Fly above the clouds", { bold: 2, curious: 1 }],
    ["Open a door to anywhere", { curious: 2, mysterious: 1 }],
    ["Protect everyone I love", { loyal: 3 }],
    ["Invent a spell no one has seen", { creative: 2, clever: 1 }],
  ]],
];

const characters = [
  { name: "Coco", title: "The girl who dreamed of magic", text: "Full of wonder and kindness. You see magic in everything and never give up on your dream.", traits: { curious: 3, kind: 2, creative: 1 }, colors: ["#a0d2ff", "#fff8e7", "#e9b949"], image: "/img/wh/coco.jpg" },
  { name: "Qifrey", title: "The gentle atelier teacher", text: "Warm and patient on the outside, with deep secrets underneath. You protect your students with everything you have.", traits: { mysterious: 3, kind: 2, clever: 1 }, colors: ["#fff8e7", "#2b2d6e", "#e9b949"], image: "/img/wh/qifrey.jpg" },
  { name: "Agott", title: "The proud, serious apprentice", text: "Hard-working and fiercely determined. You hold yourself to the highest standard, and you soften for the right people.", traits: { proud: 3, clever: 1, bold: 1 }, colors: ["#1b1b1f", "#c1121f", "#f2f0ea"], image: "/img/wh/agott.jpg" },
  { name: "Tetia", title: "The sunny, sweet apprentice", text: "Bright, bubbly and kind. You want magic to make everyone smile.", traits: { cheerful: 3, kind: 1, creative: 1 }, colors: ["#f7b2c8", "#ffd6e0", "#ffd166"] },
  { name: "Richeh", title: "The free-spirited apprentice", text: "You do things your own way. Quietly creative, a little stubborn, and full of surprising ideas.", traits: { creative: 3, mysterious: 1, proud: 1 }, colors: ["#e6ccff", "#9fa8ff", "#fff8e7"], image: "/img/wh/richeh.jpg" },
  { name: "Olruggio", title: "The gruff, loyal craftsman", text: "Grumpy on the outside, caring on the inside. You always show up when it matters.", traits: { loyal: 3, clever: 1, bold: 1 }, colors: ["#6b5b5b", "#3a86ff", "#1b1b1f"] },
  { name: "Beldaruit", title: "The playful old master", text: "Wise, mischievous and full of jokes. You know much more than you let on.", traits: { clever: 2, cheerful: 1, mysterious: 1, kind: 1 }, colors: ["#6a2c70", "#e9b949", "#fff8e7"] },
  { name: "Alaira", title: "The sharp-minded witch", text: "Smart, direct and dependable. You keep a cool head when everyone else panics.", traits: { clever: 2, loyal: 1, proud: 1, bold: 1 }, colors: ["#f2f0ea", "#7b2cbf", "#e9b949"], image: "/img/wh/alaira.jpg" },
  { name: "Custas", title: "The brave young boy", text: "Bold and full of heart. You face scary things head-on and come out stronger.", traits: { bold: 3, cheerful: 1, kind: 1 }, colors: ["#ff6f61", "#a0d2ff", "#f2f0ea"], image: "/img/wh/custas.jpg" },
  { name: "Tartah", title: "The kind shop boy", text: "Thoughtful, gentle and good with your hands. You help others shine.", traits: { kind: 2, creative: 2, loyal: 1 }, colors: ["#2a9d8f", "#e9b949", "#fff8e7"] },
  { name: "Iguin", title: "Leader of the Brimmed Caps", text: "Mysterious, daring and hard to read. You chase forbidden knowledge without fear.", traits: { mysterious: 3, bold: 2, proud: 1 }, colors: ["#1b1b1f", "#7b2cbf", "#6b5b5b"], image: "/img/wh/iguin.jpg" },
];

export const WH = createQuiz({ traits, bank, characters });

export const WH_PAIRS = [
  ["Coco", "Qifrey"], ["Coco", "Agott"], ["Tetia", "Richeh"],
  ["Qifrey", "Olruggio"], ["Coco", "Custas"], ["Qifrey", "Beldaruit"],
];
